import {QUESTION_TYPE} from './elements/question.type.model';
import {SurveyType} from './survey.type.model';

/**
 * Question dont une page nouvelle est amorcée, pour que l'utilisateur ait quelque chose à modifier
 * plutôt qu'une page blanche.
 *
 * Un formulaire démarre sur un texte long : il recueille des réponses, il ne note rien, et le
 * commentaire n'y expliquerait aucune note — le catalogue ne le lui propose d'ailleurs pas
 * (cf. `SurveyBuilderElements`). Une enquête de satisfaction, ordinaire comme par étapes, démarre
 * sur le commentaire, qu'elle est même tenue de poser pour être diffusée.
 */
export const newPageQuestionType = (surveyType?: SurveyType): QUESTION_TYPE =>
    surveyType === SurveyType.FORM ? QUESTION_TYPE.TEXT_LONG : QUESTION_TYPE.COMMENT;
